import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'

import { ReferralCardIcon } from './referral-card-icon'

import type { ClassNameProps } from '@root/shared/react'

type GradientCardProps = {
  children: React.ReactNode
  onClick?: () => void
} & ClassNameProps

export const ReferralCard = ({ children, onClick }: GradientCardProps) => {
  return (
    <Outline onClick={onClick}>
      <Inner>{children}</Inner>
    </Outline>
  )
}

const Outline = styled.div`
  position: relative;
  display: grid;

  box-sizing: border-box;

  position: relative;
  min-height: 104px;

  background:
    radial-gradient(
      27.95% 130.51% at -2.95% -17.8%,
      var(--backgroundA-7) 0%,
      transparent 100%
    ),
    radial-gradient(
      76.59% 316.95% at 114.77% -161.02%,
      var(--backgroundA-11) 0%,
      transparent 100%
    );
  border-radius: 10px;
  padding: 1px;
  overflow: hidden;
`

const Inner = styled.div`
  border-radius: 9px;
  padding: 4px;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);

  background-color: var(--background-1);
  background-image: radial-gradient(
    104.09% 362.71% at 135.68% -217.8%,
    rgba(255, 255, 255, 0.0693) 33%,
    rgba(var(--background-11-rgb), 0.04) 66%,
    rgba(255, 255, 255, 0.0099) 100%
  );
`

ReferralCard.Header = styled.div`
  border-radius: 10px;
  background: var(--appearanceA-4);
  padding: 9px;

  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  gap: 10px;
  align-items: center;
  justify-items: start;
  justify-content: start;
`
ReferralCard.Icon = ReferralCardIcon

const Title = styled(Typography).attrs({ ellipsis: true })`
  color: var(--text-12);
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
`

ReferralCard.Title = Title

const Content = styled.div`
  padding-inline: 13px;
  padding-block: 10px 14px;
  color: var(--text-9);
  font-size: 10px;
  font-weight: 400;
  line-height: 13px;

  display: grid;
  justify-items: end;
  align-items: end;
  justify-content: start;
`
ReferralCard.Content = Content
